<iframe class="ql-video" frameborder="0" allowfullscreen="true" [src]="videoUrl" width="1300px" height="1000px"
  scrolling="no">
</iframe>
